"use strict";

const formInputErrorClassName = (name='', errors={})=>{
    return !!errors[name] ? 'form__input--error' : '';
};

export default formInputErrorClassName;
